import { useHudStore } from "../store/hudStore";
import { computeView } from "../store/selectors";
import TopBar from "../components/TopBar";
import EngineerSprite from "../components/EngineerSprite";
import { Button, Card } from "../design-system/components";

// Placeholder for the drill-in screens (main / domain / character / focus / vault)
// until Phases C–D build them. Keeps navigation working from the HUD.
export default function Soon() {
  const st = useHudStore();
  const v = computeView(st);
  const label =
    st.screen === "domain"
      ? st.domain
      : st.screen === "main"
        ? st.mains.find((m) => m.id === st.main)?.name || "Main quest"
        : st.screen === "character"
          ? "Character"
          : st.screen === "focus"
            ? "Focus timer"
            : st.screen === "vault"
              ? "Vault"
              : st.soonLabel || "This screen";
  return (
    <div className="page-frame">
      <TopBar v={v} />
      <Card className="soon-panel">
        {/* The engineer reviews the plan for the unbuilt screen. */}
        <span aria-hidden="true" style={{ width: 56, height: 72, display: "block" }}>
          <EngineerSprite variant="clipboard" />
        </span>
        <h1 className="detail-heading" style={{ fontFamily: "var(--display)", fontSize: 24, fontWeight: 700, letterSpacing: "-0.01em" }}>{label}: coming next</h1>
        <div style={{ fontSize: 13.5, fontWeight: 600, color: "var(--mut)", maxWidth: "46ch", textWrap: "balance" }}>This section is still being built. Your quests and saved progress are available on Today.</div>
        <Button variant="primary" onClick={st.goHud}>Back to the HUD</Button>
      </Card>
    </div>
  );
}
